import { CHARMS, TIER_ORDER, type CharmTier } from '../core/charms';
import type { ArtFile } from './assets';

/** Portrait illustration for one charm. */
export function charmCardKey(id: string): string {
  return `charm-card-${id}`;
}

export function charmFrameKey(tier: CharmTier): string {
  return `charm-frame-${tier}`;
}

export function charmHeaderKey(tier: CharmTier): string {
  return `charm-header-${tier}`;
}

export const CHARM_BADGE = {
  padlock: 'charm-badge-padlock',
  acorn: 'charm-badge-acorn',
  count: 'charm-badge-count',
  cooling: 'charm-badge-cooling',
} as const;

function file(key: string, path: string): ArtFile {
  // WebP first, then the png. The avif siblings are 4:4:4 and a phone image
  // decoder can reject the whole charm batch while still drawing the rest of the UI.
  return { key, path, pack: 'webp' };
}

/** Paintings for the Charms screen. Loaded when that screen opens, not with the duel. */
export function charmArtFiles(): ArtFile[] {
  const files: ArtFile[] = [];
  for (const charm of CHARMS) {
    files.push(file(charmCardKey(charm.id), `assets/charms/cards/cc_charm_${charm.id}@1x.png`));
  }
  for (const tier of TIER_ORDER) {
    files.push(file(charmFrameKey(tier), `assets/charms/frames/cc_charm_frame_${tier}@1x.png`));
    files.push(file(charmHeaderKey(tier), `assets/charms/headers/cc_charm_header_${tier}@1x.png`));
  }
  files.push(file(CHARM_BADGE.padlock, 'assets/charms/badges/cc_charm_badge_padlock@1x.png'));
  files.push(file(CHARM_BADGE.acorn, 'assets/charms/badges/cc_charm_badge_acorn-pill@1x.png'));
  files.push(file(CHARM_BADGE.count, 'assets/charms/badges/cc_charm_badge_count@1x.png'));
  files.push(file(CHARM_BADGE.cooling, 'assets/charms/badges/cc_charm_badge_cooling@1x.png'));
  return files;
}
